import _ from 'lodash'
import {
  PRODUCT_WARRANTY_PERIOD_NONE,
  PRODUCT_DELIVERY_TYPE_MAP,
  PRODUCT_CONTENT_RATING_MAP,
  PRODUCT_WARRANTY_SCOPE_LIST,
  PRODUCT_WARRANTY_STATUS_LIST,
  PRODUCT_WARRANTY_STATUS_MAP,
  DELIVERY_TYPE_FUNCTION_MAP,
  PRODUCT_ATTR_DISPLAY_MODE_MAP,
  GAME_CONTENT_TYPES,
  PROPOSAL_TYPE,
  PRODUCT_SHIP_TYPE,
  PRODUCT_SHIP_TYPE_MAP
} from '@vzmi/shp_shared_compo/constants/proposal'

export {
  PROPOSAL_PHASE_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'

/**
 * flowTypes:
 *
 * edit 新增 or 編輯頁
 * => confirm 資訊確認頁
 * => success 送出成功頁
 *
 * */
export const PAGE_FLOW = {
  INITIAL: 'initial',
  EDIT: 'edit',
  CONFIRM: 'confirm',
  SUCCESS: 'success',
  ERROR: 'error'
}

export const AUTO_APPROVE_DELAY_SEC = 5
export const AUTO_APPROVE_END_SEC = 7

export const REDIRECT_TIMEOUT = 5
export const TOAST_DURATION = 7

export const GAME_CONTENT_TYPE_OPTIONS = _.map(GAME_CONTENT_TYPES, (value, key, o) => {
  return {
    label: value,
    value
  }
})

export const CONTENT_RATING_TYPES = _.map(PRODUCT_CONTENT_RATING_MAP, (value, key, o) => {
  return {
    label: value,
    value: key
  }
})

export const ATTRIBUTE_DISPLAY_MODE_TYPES = _.map(PRODUCT_ATTR_DISPLAY_MODE_MAP, (value, key, o) => {
  return {
    label: value,
    value: key
  }
})

// 與提案子站提供的交貨期限交集："預購商品"&"訂製"&"客約"
export const INTERSECTION_DELIVERY_TYPES = Object.keys(DELIVERY_TYPE_FUNCTION_MAP)

export const PRODUCT_DELIVERY_TYPE_OPTIONS = _.map(PRODUCT_DELIVERY_TYPE_MAP, (value, key, o) => {
  return {
    label: value,
    value: key
  }
})

export const WARRANTY_SECTION_NAME = '商品保證'
export const COPY_SECTION_NAME = '賣場詳情'
export const WARRANTY_PERIOD_NONE = PRODUCT_WARRANTY_PERIOD_NONE
export const WARRANTY_PERIOD_KEYS = [WARRANTY_PERIOD_NONE, '1個月', '3個月', '6個月', '9個月', '1年', '2年', '3年', '終生永久']
export const WARRANTY_PERIOD_TYPES = _.map(WARRANTY_PERIOD_KEYS, type => ({ label: type, value: type }))

export const WARRANTY_SCOPE_OTHER = '其他'
export const WARRANTY_SCOPE_KEYS = [...PRODUCT_WARRANTY_SCOPE_LIST, WARRANTY_SCOPE_OTHER]
export const WARRANTY_SCOPE_TYPES = _.map(WARRANTY_SCOPE_KEYS, type => ({ label: type, value: type }))
export const WARRANTY_STATUS_TYPES = _.map(PRODUCT_WARRANTY_STATUS_LIST, type => {
  return { label: PRODUCT_WARRANTY_STATUS_MAP[type], value: type }
})

export const RADIO_DEFAULT_TYPES = [
  { label: '否', value: false },
  { label: '是', value: true }
]

export const RADIO_EVOUCHER_TYPES = [
  { label: '票券型_1', value: 'ticket' },
  { label: '餘額型_2', value: 'balance' }
]

export const EVOCHER_ATTRIBUTES_DATATYPES = {
  INTEGER: 'integer',
  DATETIME: 'datetime',
  STRING: 'string',
  DECIMAL: 'decimal'
}

export const CATEGORY_TYPE = {
  ZONE: 'z',
  SUB: 'sub',
  CAT: 'cat',
  CAT_ITEM: 'catItem',
  ATTR_CLUSTER: 'attrCluster'
}

export const ATTRIBUTE_CONSTRAINTS_TYPE = {
  TEXT: 'text',
  RADIOBOX: 'radiobox',
  CHECKBOX: 'checkbox',
  CUSTOM: 'custom'
}

export const OTHER_ATTRIBUTE_VALUE = '其他'
export const SKIP_REQUIRED = 'skipRequired'
export const SKIP_REQUIRED_FIELD = `setting.${SKIP_REQUIRED}`

export const PROPOSAL_LISTING_FORM_KEY = 'proposalListingForm'
export const UPDATE_LISTING_FORM_KEY = 'updateListingForm'
export const SPEC_SETTING_FORM_KEY = 'specSettingForm'
export const PRODUCT_SIZE_KEYS = ['length', 'width', 'height', 'weight']
export const SPEC_SETTING_MODAL_FIELD_MIN_LENGTH = 1
export const SPEC_ATTRIBUTE_VALIDATE_RULE_TEXT = '賣場名稱-第1層項目-第2層項目'
export { EDITOR_UPLOADER_MAX_IMAGE_WIDTH_SIZE } from '@vzmi/shp_shared_compo/constants/proposal'
export const YOUTUBE_IFRAME_WIDTH_SIZE = 640
export const MARK_AS_HIDE = '(暫隱形)'

// 單層屬性，屬性項目最多 30 個
// 雙層屬性，第一層屬性項目最多 20 個，第二層屬性項目最多 30 個
export const SPEC_ITEM_MAX_LENGTH = 30
export const FIRST_SPEC_ITEM_MAX_LENGTH = {
  ONE_LAYER: SPEC_ITEM_MAX_LENGTH,
  TWO_LAYER: 20
}

export const EXTRA_MODEL = {
  COMPLIMENTARIES: {
    title: '贈品',
    subTitle: '買就送',
    value: 'complimentaries'
  },
  SELECT_COMPLIMENTARIES: {
    title: '贈品',
    subTitle: '任選',
    value: 'selectComplimentaries'
  },
  ADDITIONAL_PURCHASE: {
    title: '加價購',
    subTitle: '超值加價購',
    value: 'additionalPurchases'
  }
}

export const EXTRA_MODEL_GROUP = {
  COMPLIMENTARY_GROUPS: {
    value: 'complimentaryGroups',
    relatedModel: EXTRA_MODEL.COMPLIMENTARIES.value
  },
  SELECT_COMPLIMENTARY_GROUPS: {
    value: 'selectComplimentaryGroups',
    relatedModel: EXTRA_MODEL.SELECT_COMPLIMENTARIES.value
  },
  ADDITIONAL_PURCHASE_GROUPS: {
    value: 'additionalPurchasesGroups',
    relatedModel: EXTRA_MODEL.ADDITIONAL_PURCHASE.value
  }
}

export const EXTRA_MODEL_VALUES = _.map(EXTRA_MODEL, ({ value }) => value)

/**
 * 各種提案單中文名稱
 */
export const PROPOSAL_TYPE_NAME = {
  [PROPOSAL_TYPE.NEW_LISTING]: '新增一般賣場',
  [PROPOSAL_TYPE.NEW_PRODUCT]: '新增贈品/加價購/屬性商品',
  [PROPOSAL_TYPE.UPDATE_COPY]: '修改賣場詳情與商品保證',
  [PROPOSAL_TYPE.UPDATE_VIDEO]: '修改賣場影片',
  [PROPOSAL_TYPE.UPDATE_IMAGE]: '修改圖片',
  [PROPOSAL_TYPE.UPDATE_ATTRIBUTE]: '修改賣場規格表',
  [PROPOSAL_TYPE.UPDATE_LISTING_MODEL]: '調整賣場屬性項目',
  [PROPOSAL_TYPE.UPDATE_LISTING]: '修改賣場資訊'
}

/**
 * 商品尺寸
 */
export const PRODUCT_VOLUME_DIMENSION = {
  L: {
    KEY: 'L',
    VALUE: 'length'
  },
  W: {
    KEY: 'W',
    VALUE: 'width'
  },
  H: {
    KEY: 'H',
    VALUE: 'height'
  }
}

export const PRODUCT_VOLUME_DIMENSION_NAMES = Object.values(PRODUCT_VOLUME_DIMENSION).map(({ VALUE }) => VALUE)

export const SHIP_TYPE_ERROR = {
  NOT_AVAILABLE_STORE_DELIVERY: `貴金屬類別不開放${_.get(PRODUCT_SHIP_TYPE_MAP, `${PRODUCT_SHIP_TYPE.HOME_STORE}.LABEL`, '')}`
}
